<script>
  export let tweets
  import { extent, max } from 'd3-array'
  import chroma from 'chroma-js'
  let maxTweets = max(tweets, (d) => d.tweets)
  let maxRetweets = max(tweets, (d) => d.retweets)
  let colorScale = chroma.scale(['hotpink', 'ffd3e9']).domain([maxTweets, 0])
  let colorScaleRetweets = chroma
    .scale(['hotpink', 'ffd3e9'])
    .domain([maxRetweets, 0])

  let formatNumber = new Intl.NumberFormat()
</script>

<div class="active-users-mobile">
  <table>
    <tr>
      <th style="text-align: right; padding-right: 10px;">Username</th>
      <th>Tweets</th>
      <th>Retweets</th>
    </tr>
    {#each tweets as tweet, index}
      <tr>
        <td style="text-align: right; padding-right: 10px;"
          ><a href="https://twitter.com/@{tweet.username}" target="_blank"
            >@{tweet.username}</a
          >
          <div
            class="avatar"
            style="background-image: url({tweet.avatar});"
          /></td
        >
        <td style="background: {colorScale(tweet.tweets)};">{tweet.tweets}</td>
        <td style="background: {colorScaleRetweets(tweet.retweets)};"
          >{formatNumber.format(tweet.retweets)}</td
        >
      </tr>
    {/each}
  </table>
</div>

<style>
  .active-users-mobile table {
    width: 100%;
  }
</style>
